riot.tag2('tab', '<yield></yield>', '', 'class="tab is-toggle acr-label-3" onclick="{select}" data-tracking="{jsonData}"', function(opts) {
    var trackingJSON = require('../../data/tracking-data');
    var tabId;
    this.mixin('bus');

    this.jsonData = JSON.stringify(trackingJSON.tabsSelector);

    this.select = function select() {
      tabId = this.root.dataset.tabId;

      this.trigger('tab:selected', tabId);

      this.bus.trigger(this.bus.EVENTS.TABS.SELECT, { id: tabId });
    };
});
